const setConfig = {
  development: {
    apiKey: "AIzaSyCRsFLUVoTxRM8SmTXaZERa469AKdBJOOs",
    authDomain: "choysan-dev.firebaseapp.com",
    databaseURL: "https://choysan-dev.firebaseio.com",
    projectId: "choysan-dev",
    storageBucket: "choysan-dev.appspot.com",
    messagingSenderId: "675685966277",
    appId: "1:675685966277:web:307e0c226971432e8eebac",
    measurementId: "G-T6XJ74QJT5"
  },
  production: {
    apiKey: "AIzaSyC941kUV7ZDjEjtBzmz-ODAmkGZc3FSS7Q",
    authDomain: "choysan-8e92d.firebaseapp.com",
    databaseURL: "https://choysan-8e92d.firebaseio.com",
    projectId: "choysan-8e92d",
    storageBucket: "choysan-8e92d.appspot.com",
    messagingSenderId: "722392086145",
    appId: "1:722392086145:web:9bb7cb993b7be775bdff80",
    measurementId: "G-XH57515YSG"
  }
}
export const firebaseConfig = setConfig[process.env.VUE_APP_TARGET_ENV]